var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import { TransactionWrapper } from "../../lib/transactionWrapper";
import { getAccountHttp } from "../../lib/nisUtils";
import { WalletsHelper } from "../../lib/storage";
import { Address } from "nem-library";
export default Vue.extend({
    data() {
        return {
            confirmedTransactions: [],
            unconfirmedTransactions: [],
        };
    },
    methods: {
        fetchTransactions(count = 10, withUnconfirmedTransactions = false, onFetched = () => { }, onError = () => { }) {
            return __awaiter(this, void 0, void 0, function* () {
                const activeWallet = yield WalletsHelper.getActive();
                if (activeWallet == null) {
                    return;
                }
                this.confirmedTransactions = null;
                this.unconfirmedTransactions = null;
                const accountHttp = getAccountHttp();
                const address = new Address(activeWallet.address);
                accountHttp.allTransactions(address, { pageSize: count }).subscribe(transactions => {
                    this.confirmedTransactions = transactions
                        .map(transaction => TransactionWrapper.fromTransaction(transaction, address))
                        .filter(info => info != null);
                    if (!withUnconfirmedTransactions || this.unconfirmedTransactions != null) {
                        onFetched(this.confirmedTransactions, this.unconfirmedTransactions || []);
                    }
                }, error => {
                    onError(error);
                });
                if (withUnconfirmedTransactions) {
                    accountHttp.unconfirmedTransactions(address).subscribe(transactions => {
                        this.unconfirmedTransactions = transactions
                            .map(transaction => TransactionWrapper.fromTransaction(transaction, address))
                            .filter(info => info != null);
                        if (this.confirmedTransactions != null) {
                            onFetched(this.confirmedTransactions, this.unconfirmedTransactions);
                        }
                    }, error => {
                        onError(error);
                    });
                }
            });
        },
    },
});



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/TransactionModule.ts
// module id = 311
// module chunks = 1